import React from 'react';

// STON.FIT logo using the provided image
export const StonLogo = ({ size = 40, className = '' }) => {
  return (
    <img
      src="/ston-logo.webp"
      alt="STON.FIT Logo"
      style={{ width: size, height: size }}
      className={`rounded-xl object-cover ${className}`}
    />
  );
};

// Full logo with wordmark
export const StonLogoFull = ({ logoSize = 36, className = '' }) => {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <StonLogo size={logoSize} />
      <img
        src="/ston-fit-wordmark.svg"
        alt="STON.FIT"
        // SVG intrinsic ratio is 188.56 × 17.14 — set width explicitly so flexbox can't collapse it
        style={{ height: logoSize * 0.44, width: logoSize * 0.44 * (188.56 / 17.14), maxWidth: 'none' }}
      />
    </div>
  );
};

export default StonLogo;
